// src/components/Intro.js
import aboutPic from '../assets/layout/images/about_pic.png';

const Intro = () => {
  return (
    <section id="intro" className="intro">
      <div
        className="container-lg intro-wrap"
        data-aos="fade-up"
        data-aos-duration="900"
        style={{ textAlign: 'center', color: '#e3e3e3', padding: '0 16px', maxWidth: 1100 }}
      >
        <div className="intro-eyebrow">ABOUT AMIESOFT</div>

        <h2 className="intro-title">
          신뢰를 기반으로, IT의 새로운 표준을 만듭니다.
        </h2>

        <p className="intro-desc">
          아미소프트는 단순한 공급자가 아니라, 고객 비즈니스 성장의 든든한 <br />
          동반자가 됩니다. 우리는 기술을 통해서 세상을 더 편리하고 안전하게 <br /> 
          만들고, 고객과 함께 성장하는 길을 걸어갑니다.
        </p>

        <img
          className="intro-icons-img"
          src={aboutPic}
          alt="Trust · Security · Speed · Scalability"
          loading="eager"
          decoding="async"
          draggable={false}
        />

        <div className="intro-en">
          <div>We are more than a technology provider</div>
          <div>We are your partner for sustainable digital growth</div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
